import {AccordionLinkGroup} from 'shared/pretty-easy-navigation/models';
import {DictionaryLink, GameCodeLink, GleamcodeLink, LanguageLaboratoryLink} from '../links';
import {NavigationContext} from '../navigation.context';

export const LearnerMoreGroup = (context: NavigationContext): AccordionLinkGroup => ({
    type: 'accordionLinkGroup',
    label: 'navigation.more',
    links: [
        GleamcodeLink(context),
        GameCodeLink(context),
        DictionaryLink(context),
        LanguageLaboratoryLink(context)
    ],
    icon: 'navigation-group__more',
});